import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-31',
  templateUrl: './cards5-examples-31.component.html'
})
export class Cards5Examples31Component {}
